<template>
    <div>
		<div id="worksends-left-sidebar-sticky" visible >
			<div id="worksends-left-sidebar-content">
				<router-link id="worksends-logo" :data-suite="suite" to="/dashboard"/>
				<span id="close-sidebar" v-b-toggle.worksends-left-sidebar-toggle>X</span>
				<router-link to="/"></router-link>
				<div id="worksends-menu">
					<div id="worksends-id-card" class="loading">
						<div class="company-logo">
							<img v-if="$store.state.currentUser.logo_url" :src="$store.state.currentUser.logo_url" alt="">
						</div>
						<div v-if="$store.state.currentUser.name" class="user-name">
							{{$store.state.currentUser.name }}
						</div>
                        
						<div v-if="$store.state.currentUser.team_name" class="team-name">
							{{ $store.state.currentUser.team_name }}
                        </div>
                        
                        <div class="id-card-menu">
                            <router-link class="id-card-menu-link" to="/settings">Your Account</router-link>
                            <a v-if="$store.state.currentUser.is_bb_admin" class="id-card-menu-link" :href="wpAdminUrl" target="_blank">
                                BB HUB Admin Panel
                            </a>
                            <a class="id-card-menu-link"
                                v-if="$store.state.currentUserTeams && $store.state.currentUserTeams.length > 1"
                                 @click="openTeamSwitcher">Switch Team
                            </a>
                            <a v-if="!demo.isDemo" class="id-card-menu-link" @click="onLogout">
                                Sign Out
                            </a>
                        </div>
					</div>
					<WSMenu menuName="main-menu" :menuLinks="menuLinks"/>
                    <WSMenu menuName="bottom-menu" :menuLinks="bottomMenuLinks"/>
				</div>
			</div>
		</div>
        <div id="worksends-left-sidebar-resizer" @mousedown="triggerSidebarResize">
            <div class="resizer"></div>
        </div>
    </div>
</template>

<script>
import WSMenu from './WSMenu';
import { hubBaseUrl } from '@/utils/hub-url';

export default {
    name: 'NavSidebar',
    props: ['menuLinks', 'bottomMenuLinks', 'suite'],
    components: {
        WSMenu,
    },
    computed: {
        demo() {
            return this.$store.state.demo;
        },
        wpAdminUrl() {
            return `${hubBaseUrl}/wp-admin`;
        },
    },
    methods: {
        async onLogout() {
            await this.$store.dispatch('onLogout');
            this.$router.push('/login');
        },
        openContactModal() {
            this.$store.state.modals.contactModal = true;
        },
        openTeamSwitcher() {
			if (this.$store.state.sidebarShown) this.$root.$emit('bv::toggle::collapse', 'worksends-left-sidebar-toggle');
            this.$store.state.modals.teamSwitcher = true;
        },
        triggerSidebarResize() {
            let mode = 'compact';
            if (this.$store.state.sidebarMode == 'compact') mode = 'full';
            this.$store.state.sidebarMode = mode;
            localStorage.setItem('wsSidebarMode',mode);
        },
    },
    mounted() {
        this.$store.dispatch('removeIDCardLoading');
    },
};
</script>
